export const getIntegerFromString = val => {
  if (typeof val === "number") {
    return val;
  }
  if (typeof val === "string") {
    return parseFloat(val.replace(/[^0-9\.]+/g, ""));
  }
};
